import { useKeycloak } from "@react-keycloak/web";

import { useEffect } from "react";

export default function LoginKeycloak() {
  const { keycloak } = useKeycloak();

  useEffect(() => {
    keycloak.login({
      redirectUri: `${window.location.origin}/auth/confirmLogin`,
    }).then(() => {
      console.log("Login successful");
    })
  }, []);

  return <></>;
}
